import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import API_ENDPOINTS from "../../config/api";
import axios from "axios";
import axiosClient from "../../config/axiosClient";

const RegulationModal = ({ show, onClose, onSave, initialData, defaultType }) => {
  const [formData, setFormData] = useState({
    id: 0,
    type: "General",
    company: "PEX Picon Luxcom",
    parentId: "",
    version: 1,
    departmentIds: [],
    targetUserId: "",
    title: "",
    content: "",
    effectiveDate: "",
    status: "Draft",
    notes: "",
    userId: "",
    documentFile: null,
    documentUrl: "" // Đã đổi thành documentUrl để khớp với database
  });

  const [departments, setDepartments] = useState([]);
  const [parentPolicies, setParentPolicies] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(API_ENDPOINTS.departments, { headers: { Authorization: `Bearer ${token}` } });
        setDepartments(response.data || []);
      } catch (error) { console.error("❌ Không thể tải danh sách phòng ban:", error); }
    };

    const fetchParentPolicies = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(API_ENDPOINTS.regulations, { headers: { Authorization: `Bearer ${token}` } });
        setParentPolicies(response.data || []);
      } catch (error) { console.error("❌ Không thể tải danh sách chính sách gốc:", error); }
    };

    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const userEndpoint = API_ENDPOINTS.users || `${API_ENDPOINTS.url || ""}/api/users`;
        const response = await axios.get(userEndpoint, { headers: { Authorization: `Bearer ${token}` } });
        setUsers(response.data || []);
      } catch (error) { console.error("❌ Không thể tải danh sách nhân viên:", error); }
    };

    if (show) { fetchDepartments(); fetchParentPolicies(); fetchUsers(); }
  }, [show]);

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        departmentIds: Array.isArray(initialData.departmentIds) ? initialData.departmentIds.map(Number) : [],
        targetUserId: initialData.targetUserId ? String(initialData.targetUserId) : "",
        effectiveDate: initialData.effectiveDate ? initialData.effectiveDate.substring(0, 10) : "",
        // Lấy chính xác tên thuộc tính DocumentUrl từ database/API trả về
        documentUrl: initialData.documentUrl || initialData.DocumentUrl || "" 
      });
    } else {
      setFormData({
        id: 0, type: defaultType || "General", company: "PEX Picon Luxcom", parentId: "",
        version: 1, departmentIds: [], targetUserId: "", title: "", content: "",
        effectiveDate: new Date().toISOString().substring(0, 10), status: "Draft", notes: "", userId: "", 
        documentFile: null, documentUrl: ""
      });
    }
  }, [initialData, show, defaultType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => { setFormData((prev) => ({ ...prev, documentFile: e.target.files[0] })); };

  // Hàm xử lý đường dẫn file an toàn
const formatFileUrl = (url) => {
    if (!url) return "";
    const cleanUrl = url.replace(/\\/g, "/");
    let baseUrl = API_ENDPOINTS.url || axiosClient.defaults.baseURL || "";
    if (baseUrl.endsWith("/")) {
      baseUrl = baseUrl.slice(0, -1);
    }
    const cleanFileUrl = cleanUrl.startsWith("/") ? cleanUrl : "/" + cleanUrl;
    return cleanUrl.startsWith("http") ? cleanUrl : `${baseUrl}/api${cleanFileUrl}`;
  };

  const handleDeptCheckboxChange = (deptId) => {
    setFormData((prev) => {
      const currentIds = prev.departmentIds || [];
      const newIds = currentIds.includes(deptId) ? currentIds.filter((id) => id !== deptId) : [...currentIds, deptId];
      return { ...prev, departmentIds: newIds };
    });
  };

  const toggleSelectAllDepartments = () => {
    setFormData((prev) => ({
      ...prev,
      departmentIds: prev.departmentIds.length === departments.length ? [] : departments.map(d => d.id)
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.parentId) {
      if (formData.type === "General" && formData.departmentIds.length === 0) {
        alert("Since a Parent Policy is selected, Applied Departments are required.");
        return;
      }
      if (formData.type === "Personal" && !formData.targetUserId) {
        alert("Since a Parent Policy is selected, Target User is required.");
        return;
      }
    }

    const sendData = new FormData();
    const regulationFields = ["id", "type", "company", "version", "title", "content", "effectiveDate", "status", "notes", "parentId", "targetUserId"];

    regulationFields.forEach(field => {
      let value = formData[field];
      if (value === null || value === undefined || value === "") return;
      if (field === "effectiveDate" && value === "0001-01-01") return;
      const pascalKey = field.charAt(0).toUpperCase() + field.slice(1);
      sendData.append(`regulation.${pascalKey}`, value);
    });

    if (formData.type === "General" && Array.isArray(formData.departmentIds)) {
      formData.departmentIds.forEach((id) => sendData.append("departmentIds", id));
    }

    if (formData.documentFile instanceof File) {
      sendData.append("documentFile", formData.documentFile);
    }

    await onSave(sendData);
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title className="small fw-bold text-uppercase">
          {initialData ? `Edit ${formData.type}` : `Add New ${formData.type}`}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">Target Company <span className="text-danger">*</span></Form.Label>
                <Form.Select name="company" size="sm" value={formData.company} onChange={handleChange} required>
                  <option value="PEX Picon Luxcom">PEX Picon Luxcom</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">Classification Type <span className="text-danger">*</span></Form.Label>
                <Form.Select name="type" size="sm" value={formData.type} onChange={handleChange} required>
                  <option value="General">General (Chung)</option>
                  <option value="Personal">Personal (Cá nhân)</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">Document Version <span className="text-danger">*</span></Form.Label>
                <Form.Control type="number" name="version" size="sm" min="1" value={formData.version} onChange={handleChange} required />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label className="small fw-bold">Parent Policy (Optional)</Form.Label>
                <Form.Select name="parentId" size="sm" value={formData.parentId} onChange={handleChange}>
                  <option value="">Leave blank if this is the Root policy</option>
                  {parentPolicies.filter((p) => p.id !== formData.id).map((p) => (
                    <option key={p.id} value={p.id}>[{p.id}] - {p.title}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {formData.type === "General" && (
            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <Form.Label className="small fw-bold mb-0">
                  Applied Departments {formData.parentId && <span className="text-danger">*</span>}
                </Form.Label>
                <Button variant="link" size="sm" className="p-0 small" onClick={toggleSelectAllDepartments}>
                  {formData.departmentIds.length === departments.length ? "Uncheck All" : "Check All"}
                </Button>
              </div>
              <div className="p-2 border rounded bg-light" style={{ maxHeight: "150px", overflowY: "auto" }}>
                <Row>
                  {departments.map((dept) => (
                    <Col md={4} key={dept.id}>
                      <Form.Check type="checkbox" label={dept.name} checked={formData.departmentIds.includes(dept.id)} onChange={() => handleDeptCheckboxChange(dept.id)} />
                    </Col>
                  ))}
                </Row>
              </div>
            </Form.Group>
          )}

          {formData.type === "Personal" && (
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">
                Target User {formData.parentId && <span className="text-danger">*</span>}
              </Form.Label>
              <Form.Select name="targetUserId" size="sm" value={formData.targetUserId} onChange={handleChange}>
                <option value="">Select an employee</option>
                {users.map((u) => (
                  <option key={u.id} value={String(u.id)}>{u.employeeName || u.fullName || u.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Effective Date <span className="text-danger">*</span></Form.Label>
            <Form.Control type="date" name="effectiveDate" size="sm" value={formData.effectiveDate} onChange={handleChange} required />
          </Form.Group>

          <hr />
          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Document Title <span className="text-danger">*</span></Form.Label>
            <Form.Control type="text" name="title" size="sm" value={formData.title} onChange={handleChange} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Status</Form.Label>
            <Form.Select name="status" size="sm" value={formData.status} onChange={handleChange}>
              <option value="Draft">Draft</option>
              <option value="Public">Public</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Detailed Content <span className="text-danger">*</span></Form.Label>
            <Form.Control as="textarea" rows={3} name="content" size="sm" value={formData.content} onChange={handleChange} required />
          </Form.Group>

        <Form.Group className="mb-3">
  <div className="d-flex justify-content-between align-items-center">
    <Form.Label className="small fw-bold">Attachment File</Form.Label>
    {formData.documentUrl && (
      <a 
        href={formatFileUrl(formData.documentUrl)} 
        target="_blank" 
        rel="noreferrer" 
        className="btn btn-link btn-sm p-0 text-primary"
      >
        <i className="fas fa-eye me-1"></i> 
        {formData.documentFile ? "File selected (Click to view current)" : "View Current File"}
      </a>
    )}
  </div>
  <Form.Control type="file" size="sm" accept=".pdf,.doc,.docx,.xls,.xlsx" onChange={handleFileChange} />
  {formData.documentFile && <small className="text-success">New file: {formData.documentFile.name}</small>}
</Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="small fw-bold">Notes</Form.Label>
            <Form.Control as="textarea" rows={2} name="notes" size="sm" value={formData.notes} onChange={handleChange} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={onClose}>Close</Button>
          <Button variant="primary" size="sm" type="submit">Save Document</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default RegulationModal;